import styled from "@emotion/styled";
import Phone from "@engineering/icons/phone";
var ContactText = /*#__PURE__*/ styled("div", {
    target: "e1xtd0ce0"
})("margin-bottom:1rem;text-align:center;");
var PhoneNumberContainer = /*#__PURE__*/ styled("div", {
    target: "e1xtd0ce1"
})("padding-top:3rem;padding-bottom:3rem;display:flex;flex-direction:column;align-items:center;");
var PhoneNumberIcon = /*#__PURE__*/ styled(Phone, {
    target: "e1xtd0ce2"
})("fill:currentcolor;width:1.5rem;height:1.5rem;");
export { ContactText, PhoneNumberContainer, PhoneNumberIcon };
